import { render, staticRenderFns } from "./BindsListItemButton.vue?vue&type=template&id=3efdd3e4&"
import script from "./BindsListItemButton.vue?vue&type=script&lang=js&"
export * from "./BindsListItemButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports